import { type FC, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { getLabelAsNumberInternationalFormat, removeSpacesFromNumericString } from 'shared/lib'
import { IntegrationKey } from 'entities/Integrations/api/types'
import { Contact } from 'entities/Contacts/model/Contact'
import { type PhoneFieldSearchStore } from 'widgets/ContactsInfoForm/ui/PhoneFieldSearch'
import { PhoneInput } from 'widgets/ContactsInfoForm/ui/PhoneInput'
import styles from 'widgets/ContactsInfoForm/ui/styles.module.scss'
import { ContactsSearch } from 'widgets/ContactsSearch'

type IPhoneFieldProps = {
  store: PhoneFieldSearchStore
  value: string
  onChange: (value: string) => void
  isVariantCreateContactModal: boolean
}

export const PhoneFieldSearch: FC<IPhoneFieldProps> = observer(
  ({ store, value, isVariantCreateContactModal, onChange }) => {
    const {
      fullyNumber,
      error,
      isValidNumberLoading,
      isValidated,
      isValidNumber,
      validateNumber,
      onChangeField,
      onChangeSearch,
      number,
    } = store
    const showContactSearch = !error && fullyNumber && !isValidNumberLoading

    useEffect(() => {
      store.setNumber(value)
    }, [value])

    return (
      <>
        <PhoneInput
          value={getLabelAsNumberInternationalFormat(number)}
          errorText={error}
          isLoading={isValidNumberLoading}
          modalView={isVariantCreateContactModal}
          onBlurField={() => {
            if (isValidNumber) return
            if (!isValidated) validateNumber(number)
          }}
          onChangeValue={(value) => {
            if (removeSpacesFromNumericString(value) === number) return

            const correctNumber = onChangeField(value, number)

            onChange(correctNumber)
          }}
        />
        {showContactSearch && (
          <div
            className={classnames(styles.contactsSearch, {
              [styles.modalView]: isVariantCreateContactModal,
            })}
          >
            <ContactsSearch
              withBorder
              search={number}
              onChange={(contact, params) => {
                if (contact instanceof Contact) {
                  onChangeSearch(contact, params)
                }
              }}
              paramsCreateContact={{ fromConversation: false }}
              hiddenIntegrationsTabs={[IntegrationKey.asana]}
            />
          </div>
        )}
      </>
    )
  }
)
